<template>
    <div class="d-inline">
        <span
            @mouseenter="mouseover"
            @mousemove="setTooltipCoords"
            @mouseleave="mouseleave"
        >
            <slot></slot>
        </span>

        <div ref="floatTooltip" class="float-tooltip hide"></div>
    </div>
</template>

<script>
export default {
    name: 'Tooltip',
    props: {
        title: {
            type: String,
            default: 'title'
        },
        xDiff: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            tooltip: null
        }
    },
    mounted() {
        this.tooltip = this.$refs.floatTooltip
        window.addEventListener('scroll', this.mouseleave)
    },
    destroyed() {
        window.removeEventListener('scroll', this.mouseleave)
    },
    methods: {
        setTooltipCoords(e) {
            this.tooltip.style.top = `${e.y + 30}px`
            this.tooltip.style.left = `${e.x + this.xDiff}px`
        },
        mouseover(e) {
            this.tooltip.innerHTML = this.title
            this.setTooltipCoords(e)
            this.tooltip.classList.remove('hide')
        },
        mouseleave() {
            this.tooltip.classList.add('hide')
        }
    }
}
</script>
